import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../services/auth.service';
import { TaskNotificationItem, TaskService } from '../../services/task-service';
import { ToastService } from '../../services/toast-service';

@Component({
  selector: 'app-header',
  imports: [CommonModule, NgbTooltipModule],
  standalone: true,
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  public taskService = inject(TaskService);
  public authService = inject(AuthService);
  public toastService = inject(ToastService);

  user = toSignal(this.authService.user$);

  isNotificationsOpen = signal(false);

  hasCompletedOrErrorTasks = computed(() =>
    this.taskService.tasks().some((t) => t.status === 'completed' || t.status === 'error' || t.status === 'cancelled')
  );

  toggleNotifications() {
    this.isNotificationsOpen.update((v) => !v);
  }

  clearCompleted() {
    this.taskService.clearCompletedTasks();
  }

  cancelTask(task: TaskNotificationItem, event?: Event) {
    event?.stopPropagation();
    const message = task.status === 'active' ? `Interrompere l'elaborazione di "${task.label}"?` : `Rimuovere "${task.label}" dalla coda?`;
    if (!confirm(message)) return;

    this.taskService.cancelTask(task).subscribe({
      next: (res) => this.toastService.show(res.status === 'CANCELLED' ? 'Task rimosso dalla coda' : 'Richiesta di annullamento inviata', 'info'),
      error: () => this.toastService.show('Impossibile annullare il task (potrebbe essere già terminato)', 'error'),
    });
  }

  removeTask(id: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.taskService.removeTask(id);
  }

  // --- LOGICA UTENTE ---
  getInitials(firstName?: string, lastName?: string): string {
    const first = firstName?.charAt(0) || '';
    const last = lastName?.charAt(0) || '';
    return (first + last).toUpperCase() || 'U'; 
  }

  logout() {
    this.authService.logout();
  }
}